import axios from "axios";
import { CreditCard, SessionRequest, ReceiptTrx, SessionCatalog, ResponseViewModel, SiteSettings, UserBrowserInfo } from "../types";
import { authHook, fetchGuestEmail } from './helper-service';
import { isDev } from "../utils";
import { ProductCategory } from "../types-enums";
const TIME_OUT = isDev ? 60000 : 60000;
export class TopupService {
    @authHook
    static async fetchSession(sessionId: string, countryCode?: string) {
        let url = `/api/trx/fetch-session-catalog2/${sessionId}`;
        if (countryCode) {
            url = `${url}?countryCode=${countryCode}`
        }
        const response = await axios.get(url, {
            withCredentials: true,
        });
        const sessionData = response.data as { responseCode: number, payLoad: SessionCatalog };
        if (sessionData.payLoad && sessionData.payLoad.session &&
            !sessionData.payLoad.session.skuCategory) {
            sessionData.payLoad.session.skuCategory = 1;
        }
        return sessionData;
    }
    @authHook
    static async fetchSessionByCategory(sessionId: string, category: ProductCategory, countryCode?: string) {
        let url = `/api/trx/fetch-session-catalog-by-category/${sessionId}/${category}`;
        if (countryCode) {
            url = `${url}?countryCode=${countryCode}`
        }
        const response = await axios.get(url, {
            withCredentials: true,
        });
        const sessionData = response.data as { responseCode: number, payLoad: SessionCatalog };
        if (sessionData.payLoad && sessionData.payLoad.session &&
            !sessionData.payLoad.session.skuCategory) {
            sessionData.payLoad.session.skuCategory = 1;
        }
        return sessionData;
    }
    @authHook
    static async fetchHomeCurrency() {
        const guestEmail = fetchGuestEmail();
        const response = await axios.post(`/api/trx/home-currency?isGuest=${guestEmail ? "true" : "false"}`, {}, { withCredentials: true });
        return response.data as ResponseViewModel<string>;
    }
    @authHook
    static async getStorePinBalance(session: SessionRequest) {
        const response = await axios.post(`/api/trx/get-store-pin-balance`, {
            countryCode: session.countryCode,
            mobileNumber: session.mobileNumber,
            sessionId: session.sessionId,
            skuId: session.skuId,
            sourceCurrencyCode: session.sourceCurrencyCode,            
            promoCode: session.promoCode,
            aicId: session.aicId,
            reachedPaymentPage: session.reachedPaymentPage,
        }, { withCredentials: true, });
        const dt = response.data;// as { payLoad: SessionCatalog, responseCode: number, responseMessage: string };
        debugger;
        return dt;
    }
    @authHook
    static async saveSession(session: SessionRequest) {
        const response = await axios.post(`/api/trx/save-session2`, {
            countryCode: session.countryCode,
            mobileNumber: session.mobileNumber,
            sessionId: session.sessionId,
            skuId: session.skuId,
            sourceCurrencyCode: session.sourceCurrencyCode,
            sms: session.sms,
            coverSalesTax: session.coverSalesTax,
            promoCode: session.promoCode,
            rewardPointsUsed: session.rewardPointsUsed,
            campaignId: session.campaignId,
            campaignMemberId: session.campaignMemberId,
            aicId: session.aicId,
            reachedPaymentPage: session.reachedPaymentPage,
            productCategory: session.productCategory,
            senderMobile: session.senderMobile,
            senderFullName: session.senderFullName,
            recipientMobile: session.recipientMobile,
            recipientEmail: session.recipientEmail,
            recipientFullName: session.recipientFullName,
            recipientMessage: session.recipientMessage,
            guestEmail: session.guestEmail
        }, { withCredentials: true, });
        const dt = response.data as { payLoad: SessionCatalog, responseCode: number, responseMessage: string };
        // if (dt.payLoad && dt.payLoad.session) dt.payLoad.session.isValidMobileNumber = true;
        return dt;
    }
    @authHook
    static async postCCTransaction(sessionId: string, ccInfo: CreditCard, fingerPrintSessions: { [key: string]: string }, userBrowserInfo: UserBrowserInfo) {
        const model = {
            sessionid: sessionId,
            ccInfo: ccInfo,
            fingerPrintSessions: fingerPrintSessions,
            userBrowserInfo: userBrowserInfo
        };
        const response = await axios.post(`/api/trx/post-cc-transaction`, model, {
            withCredentials: true,
            timeout: TIME_OUT
        });
        const dt = response.data as { responseCode: number, responseMessage: string, payLoad: ReceiptTrx };
        return dt;
    }
    @authHook
    static async postStoredCCTransaction(sessionId: string, cvvCode: string, creditCardId: number, fingerPrintSessions: { [key: string]: string }, userBrowserInfo: UserBrowserInfo) {
        // await TopupService.delay(65000);
        // return {responseCode: 0, responseMessage: "", payLoad: 373646698};
        // const params = new URLSearchParams();
        // params.append("sessionId", sessionId);
        // params.append("fingerprintSessionId", webSessionId);
        // if (cvvCode) params.append("cvvCode", cvvCode);
        // if (creditCardId) params.append("creditCardId", creditCardId.toString());
        const model = {
            sessionid: sessionId,
            tokenInfo: { cvvCode: cvvCode, permanentTokenId: creditCardId },
            fingerPrintSessions: fingerPrintSessions,
            userBrowserInfo: userBrowserInfo
        };
        const response = await axios.post(`/api/trx/post-stored-cc-transaction`, model, {
            withCredentials: true,
            timeout: TIME_OUT
        });
        const dt = response.data as { responseCode: number, responseMessage: string, payLoad: ReceiptTrx };
        return dt;
    }
    @authHook
    static async proces3DTransaction(threeDTrxId: number) {
        //await TopupService.delay(5000);
        const params = new URLSearchParams();
        params.append("id", "" + threeDTrxId);
        const response = await axios.post(`/api/trx/process-3d`, params, {
            withCredentials: true,
            timeout: TIME_OUT
        });
        const dt = response.data as { responseCode: number, responseMessage: string, payLoad: ReceiptTrx };
        return dt;
    }
    @authHook
    static async postZZTransaction(sessionId: string) {
        const params = new URLSearchParams();
        params.append("sessionId", sessionId);
        const response = await axios.post(`/api/trx/post-zz-transaction`, params, {
            withCredentials: true,
            timeout: TIME_OUT
        });
        const dt = response.data as { responseCode: number, responseMessage: string, payLoad: ReceiptTrx };
        return dt;
    }
    @authHook
    static async initiatePaypalTransaction(sessionId: string, successUrl: string, cancelUrl: string) {
        const params = new URLSearchParams();
        params.append("sessionId", sessionId);
        params.set("successUrl", successUrl);
        params.set("cancelUrl", cancelUrl);
        const response = await axios.post(`/api/trx/post-desktop-pp-transaction`, params, {
            withCredentials: true,
        });
        const dt = response.data as { responseCode: number, responseMessage: string, payLoad: { redirectUrl: string } };
        return dt;
    }
    @authHook
    static async processPaypalTransaction(sid: string, token: string, payerId: string) {        
        const response = await axios.post(`/api/trx/process-paypal`,  {
            sid,
            token,
            payerId
          }, {
            withCredentials: true,
            timeout: TIME_OUT
        });
        const dt = response.data as { responseCode: number, responseMessage: string, payLoad: ReceiptTrx };
        return dt;
    }
    @authHook
    static async fetchReceipt(transactionId?: number, sessionId?: string, guestTrxId?: string) {
        const response = await axios.get(`/api/trx/receipt`, {
            withCredentials: true,
            params: { id: transactionId, sid: sessionId, guestTrxId: guestTrxId }
        });
        const receipt = response.data as ResponseViewModel<ReceiptTrx>;
        return receipt;
    }
    @authHook
    static async getFingerprintTags(sid: string, sourceCurrencyCode: string) {
        const response = await axios.get(`/api/trx/get-fingerpint-tags?sessionId=${sid}&sourceCurrencyCode=${sourceCurrencyCode}`, {
            withCredentials: true
        });
        return response.data as { payLoad: Array<{ [key: string]: string }> };
    }
    @authHook
    static async fetchSiteSettings() {
        const response = await axios.get(`/api/trx/site-settings`, {
            withCredentials: true
        });
        return response.data as ResponseViewModel<SiteSettings>;
    }
    @authHook
    static async resendGiftCardEmail(trxId: number) {
        const response = await axios.get(`/api/trx/resend-giftcard-email/${trxId}`, { withCredentials: true });
        return response.data as ResponseViewModel;
    }
    static getTransactionStatus(receipt: { transactionStatus: string }) {
        if (!receipt) return '';
        switch (receipt.transactionStatus) {
            case 'PaymentPending':
            case 'Pending':
                return 'pending';
            case 'Successful':
                return 'success';
            case 'PaymentFailed':
            case 'Failed':
            case 'Unknown':
                return 'failed';
            default:
                return 'failed';
        }
    }
}